import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  EditUserSingleOrder,
  GetUserSingleOrder,
} from '../../../redux/user/user_order/user_order_services_sync';
import { useNavigate, useParams } from 'react-router-dom';
import LoaderScreen from '../../../component/loader/loaderScreen';
import CurrencyFormatter from '../../../component/CurrencyFormatter';
import moment from 'moment';
import Select from 'react-select';
import {
  MyOrderSelection,
  SelectionSingleOrder,
} from '../../../utils/orderSelection';
import { Skeleton } from '@mui/material';
import {
  updateCurrentRoom,
  updateSelectedRoom,
} from '../../../redux/user/room/roomSlice';
import { AppContext } from '../../../context/context';
import CustomModal from '../../../component/dashboard/user_generalComponent/CustomModal';

const User_OrdersDetails = () => {
  const { viewId } = useParams();

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { socket } = useContext(AppContext);

  const { profile } = useSelector((state) => state.user_profile);

  const { current_room } = useSelector((state) => state.room);

  const {
    myOrderDetails,
    my_order_details_loader,
    my_single_order_status,
    order_edit_single_loader,
  } = useSelector((state) => state.user_order);

  useEffect(() => {
    dispatch(GetUserSingleOrder({ Id: viewId }));
  }, [viewId]);

  const handleChangeSelectionStatus = (selectedOption) => {
    dispatch(
      EditUserSingleOrder({
        orderId: myOrderDetails?._id,
        status: selectedOption?.value,
      })
    );
  };

  const JoinRoom = async (room, currentRoom, isPublic = true) => {
    if (!profile) {
      return alert('please login');
    }

    await navigate('/user_dashboard/chat');

    socket.emit('join-room', room.room, currentRoom, room);

    dispatch(updateCurrentRoom(room.room));

    dispatch(updateSelectedRoom(room));
  };

  return (
    <>
      {my_order_details_loader && <LoaderScreen />}

      {!my_order_details_loader && (
        <div class="row">
          <div class="col-xl-9 col-lg-8">
            <div class="row">
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
                      <div>
                        <h4 class="fw-medium text-dark d-flex align-items-center gap-2">
                          <span
                            onClick={() => {
                              const payload = {
                                ...myOrderDetails,
                                room: `${myOrderDetails?._id}-${myOrderDetails?.createdBy}-admin`,
                              };

                              JoinRoom(payload, current_room);
                            }}
                            className="cursor-pointer"
                          >
                            #{myOrderDetails?._id?.slice(0, 10)}...{' '}
                          </span>
                          <span
                            class={`badge ${
                              myOrderDetails?.payment_status === 'paid'
                                ? 'bg-success-subtle text-success'
                                : 'bg-light-subtle text-dark'
                            } px-2 py-1 fs-13 capitalize`}
                          >
                            {myOrderDetails?.payment_status}
                          </span>
                          <span
                            class={`border ${
                              myOrderDetails?.status === 'pending'
                                ? 'border-secondary text-secondary'
                                : myOrderDetails?.status === 'processing'
                                ? 'border-warning text-warning'
                                : myOrderDetails?.status === 'cancelled'
                                ? 'border-danger text-danger'
                                : 'border-success text-success'
                            } fs-13 px-2 py-1 rounded`}
                          >
                            {myOrderDetails?.status}
                          </span>
                        </h4>
                        <p class="mb-0">
                          Order / Order Details / #
                          {myOrderDetails?._id?.slice(0, 10)}... -{' '}
                          {moment(myOrderDetails?.createdAt).format(
                            'MMM, DD YYYY hh:mm A'
                          )}
                        </p>
                      </div>
                      <div className="flex items-center gap-6">
                        <div style={{ minWidth: '10rem' }}>
                          <button
                            className="badge border text-secondary px-2 fs-13 capitalize"
                            onClick={async () => {
                              setIsModalOpen(!isModalOpen);
                            }}
                          >
                            Add Address
                          </button>
                        </div>

                        <div style={{ minWidth: '10rem' }}>
                          {!order_edit_single_loader ? (
                            <Select
                              defaultValue={my_single_order_status}
                              onChange={handleChangeSelectionStatus}
                              options={MyOrderSelection}
                            />
                          ) : (
                            <Skeleton
                              height={60}
                              width={'100%'}
                              style={{ margin: 0 }}
                            />
                          )}
                        </div>
                      </div>
                    </div>

                    <div class="mt-4">
                      <h4 class="fw-medium text-dark capitalize">
                        Order {myOrderDetails?.status}
                      </h4>
                    </div>
                    <div class="row row-cols-xxl-5 row-cols-md-2 row-cols-1">
                      <div class="col">
                        <div class="progress mt-3" style={{ height: '10px' }}>
                          <div
                            class={`progress-bar progress-bar  progress-bar-striped progress-bar-animated ${
                              myOrderDetails?.status === 'cancelled'
                                ? 'bg-danger'
                                : myOrderDetails?.status === 'pending' ||
                                  myOrderDetails?.status === 'processing' ||
                                  myOrderDetails?.status === 'shipping' ||
                                  myOrderDetails?.status === 'delivered'
                                ? 'bg-success'
                                : 'bg-primary'
                            }`}
                            role="progressbar"
                            style={{
                              width:
                                myOrderDetails?.status === 'pending' ||
                                myOrderDetails?.status === 'processing' ||
                                myOrderDetails?.status === 'shipping' ||
                                myOrderDetails?.status === 'delivered' ||
                                myOrderDetails?.status === 'cancelled'
                                  ? '100%'
                                  : '0%',
                            }}
                            aria-valuenow="70"
                            aria-valuemin="0"
                            aria-valuemax="70"
                          ></div>
                        </div>
                        <p class="mb-0 mt-2">Pending</p>
                      </div>
                      <div class="col">
                        <div class="progress mt-3" style={{ height: '10px' }}>
                          <div
                            class={`progress-bar progress-bar  progress-bar-striped progress-bar-animated ${
                              myOrderDetails?.status === 'cancelled'
                                ? 'bg-danger'
                                : myOrderDetails?.status === 'processing' ||
                                  myOrderDetails?.status === 'shipping' ||
                                  myOrderDetails?.status === 'delivered'
                                ? 'bg-success'
                                : 'bg-primary'
                            }`}
                            role="progressbar"
                            style={{
                              width:
                                myOrderDetails?.status === 'processing' ||
                                myOrderDetails?.status === 'shipping' ||
                                myOrderDetails?.status === 'delivered' ||
                                myOrderDetails?.status === 'cancelled'
                                  ? '100%'
                                  : '0%',
                            }}
                            aria-valuenow="70"
                            aria-valuemin="0"
                            aria-valuemax="70"
                          ></div>
                        </div>
                        <div class="d-flex align-items-center gap-2 mt-2">
                          <p class="mb-0">Processing</p>

                          {myOrderDetails?.status === 'pending' && (
                            <div
                              class="spinner-border spinner-border-sm text-warning"
                              role="status"
                            >
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div class="col">
                        <div class="progress mt-3" style={{ height: '10px' }}>
                          <div
                            class={`progress-bar progress-bar  progress-bar-striped progress-bar-animated ${
                              myOrderDetails?.status === 'cancelled'
                                ? 'bg-danger'
                                : myOrderDetails?.status === 'shipping' ||
                                  myOrderDetails?.status === 'delivered'
                                ? 'bg-success'
                                : 'bg-primary'
                            }`}
                            role="progressbar"
                            style={{
                              width:
                                myOrderDetails?.status === 'shipping' ||
                                myOrderDetails?.status === 'delivered' ||
                                myOrderDetails?.status === 'cancelled'
                                  ? '100%'
                                  : '0%',
                            }}
                            aria-valuenow="70"
                            aria-valuemin="0"
                            aria-valuemax="70"
                          ></div>
                        </div>
                        <div class="d-flex align-items-center gap-2 mt-2">
                          <p class="mb-0">Shipping</p>
                          {myOrderDetails?.status === 'processing' && (
                            <div
                              class="spinner-border spinner-border-sm text-warning"
                              role="status"
                            >
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div class="col">
                        <div class="progress mt-3" style={{ height: '10px' }}>
                          <div
                            class={`progress-bar progress-bar  progress-bar-striped progress-bar-animated ${
                              myOrderDetails?.status === 'cancelled'
                                ? 'bg-danger'
                                : myOrderDetails?.status === 'delivered'
                                ? 'bg-success'
                                : 'bg-primary'
                            }`}
                            role="progressbar"
                            style={{
                              width:
                                myOrderDetails?.status === 'delivered' ||
                                myOrderDetails?.status === 'cancelled'
                                  ? '100%'
                                  : '0%',
                            }}
                            aria-valuenow="70"
                            aria-valuemin="0"
                            aria-valuemax="70"
                          ></div>
                        </div>
                        <div class="d-flex align-items-center gap-2 mt-2">
                          <p class="mb-0">Delivered</p>

                          {myOrderDetails?.status === 'shipping' && (
                            <div
                              class="spinner-border spinner-border-sm text-warning"
                              role="status"
                            >
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div class="col">
                        <div class="progress mt-3" style={{ height: '10px' }}>
                          <div
                            class={`progress-bar progress-bar  progress-bar-striped progress-bar-animated ${
                              myOrderDetails?.status === 'cancelled'
                                ? 'bg-danger'
                                : 'bg-primary'
                            }`}
                            role="progressbar"
                            style={{
                              width:
                                myOrderDetails?.status === 'cancelled'
                                  ? '100%'
                                  : '0%',
                            }}
                            aria-valuenow="70"
                            aria-valuemin="0"
                            aria-valuemax="70"
                          ></div>
                        </div>
                        <p class="mb-0">Cancelled</p>
                      </div>
                    </div>
                  </div>
                  {/* <div class="card-footer d-flex flex-wrap align-items-center justify-content-between bg-light-subtle gap-2">
                    <p class="border rounded mb-0 px-2 py-1 bg-body">
                      <i class="bx bx-arrow-from-left align-middle fs-16"></i>{' '}
                      Estimated shipping date :{' '}
                      <span class="text-dark fw-medium">Apr 25 , 2024</span>
                    </p>
                    <div>
                      <a href="#!" class="btn btn-primary">
                        Make As Ready To Ship
                      </a>
                    </div>
                  </div> */}
                </div>
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title">Product</h4>
                  </div>
                  <div class="card-body">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-hover table-centered">
                        <thead class="bg-light-subtle border-bottom">
                          <tr>
                            <th>Product Name</th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>Total Price</th>
                            <th>color</th>
                          </tr>
                        </thead>
                        <tbody>
                          {myOrderDetails?.products?.map((goods, key) => (
                            <tr key={key}>
                              <td>
                                <div class="d-flex align-items-center gap-2">
                                  <div class="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                    <img
                                      src={
                                        goods?.gallery[0]?.pic_url ||
                                        '/assets/images/product/p-1.png'
                                      }
                                      alt=""
                                      class="avatar-md"
                                    />
                                  </div>
                                  <div>
                                    <a
                                      href="#!"
                                      class="text-dark fw-medium fs-15"
                                    >
                                      {goods?.name}
                                    </a>
                                  </div>
                                </div>
                              </td>

                              <td>{goods?.quantity}</td>
                              <td>
                                <CurrencyFormatter
                                  value={goods?.price}
                                  currency={goods?.symbol}
                                />
                              </td>
                              <td>
                                <CurrencyFormatter
                                  value={goods?.totalPrice}
                                  currency={goods?.symbol}
                                />
                              </td>
                              <td>
                                <div
                                  style={{
                                    backgroundColor: goods?.color,
                                  }}
                                  className={`w-10 h-10 rounded-full border cursor-pointer`}
                                />
                              </td>
                            </tr>
                          ))}

                          <tr>
                            <td>Total Price</td>

                            <td>
                              <CurrencyFormatter
                                value={myOrderDetails?.totalPrice}
                                currency={myOrderDetails?.symbol}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-4">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Order Summary</h4>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <tbody>
                      <tr>
                        <td class="px-0">
                          <p class="d-flex mb-0 align-items-center gap-1">
                            <iconify-icon icon="solar:clipboard-text-broken"></iconify-icon>{' '}
                            Sub Total :{' '}
                          </p>
                        </td>
                        <td class="text-end text-dark fw-medium px-0">
                          <CurrencyFormatter
                            value={myOrderDetails?.totalPrice}
                            currency={myOrderDetails?.symbol}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td class="px-0">
                          <p class="d-flex mb-0 align-items-center gap-1">
                            <iconify-icon
                              icon="solar:ticket-broken"
                              class="align-middle"
                            ></iconify-icon>{' '}
                            Total Quantity :{' '}
                          </p>
                        </td>
                        <td class="text-end text-dark fw-medium px-0">
                          {myOrderDetails?.total_quantity}
                        </td>
                      </tr>
                      {/* <tr>
                        <td class="px-0">
                          <p class="d-flex mb-0 align-items-center gap-1">
                            <iconify-icon
                              icon="solar:kick-scooter-broken"
                              class="align-middle"
                            ></iconify-icon>{' '}
                            Delivery Charge :{' '}
                          </p>
                        </td>
                        <td class="text-end text-dark fw-medium px-0">
                          $00.00
                        </td>
                      </tr>
                      <tr>
                        <td class="px-0">
                          <p class="d-flex mb-0 align-items-center gap-1">
                            <iconify-icon
                              icon="solar:calculator-minimalistic-broken"
                              class="align-middle"
                            ></iconify-icon>{' '}
                            Estimated Tax (15.5%) :{' '}
                          </p>
                        </td>
                        <td class="text-end text-dark fw-medium px-0">
                          $20.00
                        </td>
                      </tr> */}
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer d-flex align-items-center justify-content-between bg-light-subtle">
                <div>
                  <p class="fw-medium text-dark mb-0">Total Amount</p>
                </div>
                <div>
                  <p class="fw-medium text-dark mb-0">
                    <CurrencyFormatter
                      value={myOrderDetails?.totalPrice}
                      currency={myOrderDetails?.symbol}
                    />
                  </p>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Customer Details</h4>
              </div>
              <div class="card-body">
                <div class="d-flex align-items-center gap-2">
                  <img
                    src="/assets/img/avatar-profile-photo.png"
                    alt=""
                    class="avatar rounded-3 border border-light border-3"
                  />
                  <div>
                    <p class="mb-1">Gaston Lapierre</p>
                    <a href="#!" class="link-primary fw-medium">
                      {myOrderDetails?.email}
                    </a>
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-3">
                  <h5 class="">Contact Number</h5>
                </div>
                <p class="mb-1">{myOrderDetails?.phone_number || ''}</p>

                <div class="d-flex justify-content-between mt-3">
                  <h5 class="">Shipping Address one</h5>
                  <div></div>
                </div>

                <p class="mb-1">{myOrderDetails?.address_one}</p>

                <div class="d-flex justify-content-between mt-3">
                  <h5 class="">Shipping Address Two</h5>
                </div>

                <p class="mb-1">{myOrderDetails?.address_two}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {isModalOpen && (
        <CustomModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default User_OrdersDetails;
